module.exports = __webpack_public_path__ + "static/media/poster.b77402b9.jpeg";